import Chronometer from 'app/components/Chronometer'
import ConfirmableSpinnable from 'app/components/buttons/ConfirmableSpinnable'
import { format } from 'date-fns'
import DodoneStatsBase from 'app/dodones/shared/Stats/Base'

const StartedFinished = ({ dodone }) => {
  if ((!dodone.startedAt || !dodone.finishedAt) && !dodone.isIgnored)
    return null

  return (
    <div className="text-2xs digital-display frow gap-2 items-center">
      {dodone.isPrevious() && <div>[{format(dodone.day, 'E, MMM do')}]</div>}
      {dodone.startedAt && (
        <>
          {format(dodone.startedAt, 'HH:mm')}
          <i className="ph ph-arrow-right" />
        </>
      )}
      {dodone.finishedAt && <>{format(dodone.finishedAt, 'HH:mm')}</>}
    </div>
  )
}

const Trigger = ({ onClick }) => {
  return (
    <div className="dodone-list-item-icon-wrapper text-md" onClick={onClick}>
      <i className="dodone-list-item-icon" />
    </div>
  )
}

const DodoneLink = ({ dodone, children, size = 'md' }) => {
  const [startedPending, setStartedPending] = useState(false)

  const startPending = useCallback((e) => {
    setStartedPending(true)
  })

  if (startedPending)
    return <Navigate to={`/dodones/${dodone.id}?startPending=true`} replace />

  return (
    <ConfirmableSpinnable
      onConfirm={startPending}
      enabled={dodone.isPending}
      Trigger={Trigger}
      className={dodone.itemClassName({ size })}
      confirmation="Start?"
      size="xs"
    >
      <Link to={`/dodones/${dodone.id}`} className="flex-1">
        {children}
      </Link>
    </ConfirmableSpinnable>
  )
}

const DodoneItemPreview = ({ dodone, children }) => {
  return <div className={dodone.itemClassName()}>{children}</div>
}

export default ({ prefix, dodone, size = 'md' }) => {
  const Element = dodone.id ? DodoneLink : DodoneItemPreview
  // const Element = Link // Test style without a hassle

  return (
    <Element dodone={dodone} size={size}>
      <div className={`dodone-list-item-content`}>
        {prefix ? (
          <div className="dodone-list-item-content-prefix"> {prefix} </div>
        ) : null}
        <div className="dodone-list-item-text">
          {dodone.listItemText}
          <div className="flex-1" />
          <DodoneStatsBase dodone={dodone} />
        </div>
        {dodone.isOngoing && (
          <Chronometer startedAt={dodone.startedAt} size={'extra-small'} />
        )}
        <StartedFinished dodone={dodone} />
      </div>
    </Element>
  )
}
